export default __webpack_public_path__ + "static/media/emailLogs.15aa73bc.svg";